import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";

const Login = lazy(() => import("./pages/Login"));
const Signup = lazy(() => import("./pages/Signup"));
const DashboardLayout = lazy(() => import("./pages/DashboardLayout"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const VehiclesPage = lazy(() => import("./pages/VehiclesPage"));
const HistoryPage = lazy(() => import("./pages/HistoryPage"));
const NotificationsPage = lazy(() => import("./pages/NotificationsPage"));

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#00F0FF] border-t-transparent rounded-full animate-spin" /></div>}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="vehicles" element={<VehiclesPage />} />
              <Route path="history" element={<HistoryPage />} />
              <Route path="notifications" element={<NotificationsPage />} />
            </Route>

            {/* Redirect section anchors so crawlers don't 404 */}
            <Route path="/services" element={<Navigate to="/" replace state={{ scrollTo: "#services" }} />} />
            <Route path="/how-it-works" element={<Navigate to="/" replace state={{ scrollTo: "#how-it-works" }} />} />
            <Route path="/faq" element={<Navigate to="/" replace state={{ scrollTo: "#faq" }} />} />
            <Route path="/privacy" element={<Navigate to="/" replace />} />
            <Route path="/terms" element={<Navigate to="/" replace />} />
            <Route path="/contact" element={<Navigate to="/" replace state={{ scrollTo: "#booking" }} />} />
            <Route path="/about" element={<Navigate to="/" replace state={{ scrollTo: "#how-it-works" }} />} />
            <Route path="/vehicles" element={<Navigate to="/dashboard/vehicles" replace />} />
            <Route path="/history" element={<Navigate to="/dashboard/history" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
